import { LoadablePaint } from '@confluence/loadable';

export { ADFRenderer } from './ADFRenderer';
export {
	registerGlobalMediaViewedListener,
	removeGlobalMediaViewedListener,
} from './AttachmentEvents';
export { createSmartCardEventHandler } from './createSmartCardEventHandler';
export { createLinkEventHandler } from './createLinkEventHandler';
export { useEventHandlers } from './useEventHandlers';

export const ADFRendererWithExtensions = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ADFRendererWithExtensions" */ './ADFRendererWithExtensions'
			)
		).ADFRendererWithExtensions,
});

export {
	ANALYTICS_EVENT_SEVERITY_TRACKING,
	UNSUPPORTED_CONTENT_THRESHOLDS,
} from './ADFRendererComponent';
